var _circle, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#1F313A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wallet_svg__clip0_1203_31486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.833 18.165v-.833c0-1.379-1.121-2.5-2.5-2.5h-12.5a2.502 2.502 0 00-2.5 2.5v13.333c0 1.38 1.121 2.5 2.5 2.5h15c1.379 0 2.5-1.12 2.5-2.5v-10c0-1.378-1.121-2.5-2.5-2.5zm-15-1.666h12.5c.46 0 .833.373.833.833v.833H16.833a.834.834 0 010-1.666zm15 15h-15a.834.834 0 01-.833-.834V19.69c.26.093.54.143.833.143h15c.46 0 .833.374.833.833v2.084h-4.583a2.92 2.92 0 00-2.917 2.916 2.92 2.92 0 002.917 2.917h4.583v2.083c0 .46-.373.834-.833.834zm.833-4.584h-1.95a2.897 2.897 0 00-.002-2.5h1.952v2.5zm-5.833-1.25c0-.689.56-1.25 1.25-1.25a1.252 1.252 0 01.889 2.133 1.252 1.252 0 01-2.139-.882z",
    fill: "#56CCF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wallet_svg__clip0_1203_31486"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(14.333 14)",
    d: "M0 0h20v20H0z"
  })))));
};

export default SvgWallet;